module.exports = __webpack_public_path__ + "media/86.f4bb6fd7.wav";